import React from "react";
import { MessageCircle } from "lucide-react";
import { useTranslation } from "react-i18next";

export const WhatsAppButton = () => {
  const { t } = useTranslation();
  const phone = "972547003268"; // StayTLV host WhatsApp
  const text = encodeURIComponent(t("whatsapp_message"));
  const href = `https://wa.me/${phone}?text=${text}`;
  return (
    <a
      data-testid="whatsapp-cta"
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed bottom-6 end-6 z-50 inline-flex items-center gap-2 bg-[#25D366] text-white rounded-full px-4 py-3 shadow-lg hover:scale-105 transition-transform"
      aria-label={t("whatsapp")}
    >
      <MessageCircle className="h-5 w-5" />
      <span className="hidden sm:inline text-sm font-medium">{t("whatsapp")}</span>
    </a>
  );
};
